if (!customElements.get('curling-inline-zoom')) {
  customElements.define('curling-inline-zoom', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.button = this.querySelector('button');
      this.icon = this.querySelector('.curling-inline-zoom__icon');
      this.x = this.y = 50;
      this.active = false;
      this.desktop = window.matchMedia('(min-width: 750px)');
      const updateAvailability = () => {
        this.reset();
        this.button.hidden = !this.desktop.matches;
        this.button.disabled = !this.desktop.matches;
      };
      this.desktop.addEventListener('change', updateAvailability, options);
      updateAvailability();
      this.button.addEventListener('click', event => {
        event.stopPropagation();
        if (this.dragged) { this.dragged = false; return; }
        if (this.active || this.hasAttribute('data-loading')) this.reset();
        else this.zoom(event);
      }, options);
      this.button.addEventListener('pointermove', event => {
        if (!this.active) return;
        if (event.pointerType === 'mouse') this.point(event);
        else if (this.drag) {
          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          if (Math.hypot(dx, dy) > 5) this.dragged = true;
          const rect = this.getBoundingClientRect();
          this.position(this.drag.zx - dx / rect.width * 100, this.drag.zy - dy / rect.height * 100);
        }
      }, options);
      this.button.addEventListener('pointerdown', event => {
        this.dragged = false;
        if (!this.active || event.pointerType === 'mouse') return;
        event.stopPropagation();
        this.drag = { x:event.clientX, y:event.clientY, zx:this.x, zy:this.y };
        this.button.setPointerCapture(event.pointerId);
      }, options);
      this.button.addEventListener('pointerup', () => { this.drag = null; }, options);
      this.button.addEventListener('pointercancel', () => { this.drag = null; }, options);
      this.button.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') this.reset(); }, options);
      this.button.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.reset(); }
        if (!this.active || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        this.position(this.x + (event.key === 'ArrowRight' ? 10 : event.key === 'ArrowLeft' ? -10 : 0), this.y + (event.key === 'ArrowDown' ? 10 : event.key === 'ArrowUp' ? -10 : 0));
      }, options);
      this.button.addEventListener('blur', () => this.reset(), options);
      this.closest('scroll-carousel')?.addEventListener('scroll', () => this.reset(), options);
      this.closest('product-gallery')?.addEventListener('click', event => { if (!this.contains(event.target)) this.reset(); }, options);
    }
    disconnectedCallback() { this.reset(); this.abort?.abort(); }
    position(x, y) {
      this.x = Math.min(100, Math.max(0, x)); this.y = Math.min(100, Math.max(0, y));
      this.style.setProperty('--zoom-x', `${this.x}%`);
      this.style.setProperty('--zoom-y', `${this.y}%`);
    }
    point(event) {
      const rect = this.getBoundingClientRect();
      this.position((event.clientX - rect.left) / rect.width * 100, (event.clientY - rect.top) / rect.height * 100);
    }
    async zoom(event) {
      if (!this.desktop.matches) return;
      if (event.detail && event.pointerType !== 'touch') this.point(event); else this.position(50, 50);
      const token = this.token = {};
      this.setAttribute('data-loading', '');
      if (!this.loaded) {
        const image = new Image();
        image.src = this.dataset.src;
        try { await image.decode(); } catch { if (this.token === token) this.reset(); return; }
        this.loaded = true;
      }
      if (this.token !== token || !this.isConnected || !this.desktop.matches) return;
      this.style.setProperty('--zoom-image', `url("${this.dataset.src}")`);
      this.removeAttribute('data-loading');
      this.setAttribute('data-active', '');
      this.active = true;
      this.button.setAttribute('aria-pressed', 'true');
      this.button.setAttribute('aria-label', this.dataset.resetLabel);
      this.icon.textContent = '−';
    }
    reset() {
      this.token = null; this.active = false; this.drag = null;
      this.removeAttribute('data-active'); this.removeAttribute('data-loading');
      this.button?.setAttribute('aria-pressed', 'false');
      this.button?.setAttribute('aria-label', this.dataset.zoomLabel);
      if (this.icon) this.icon.textContent = '+';
    }
  });
}
